<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col sm="12" md="12" lg="10">
        <v-card>
          <v-card-title>
            Consumeables Inventory
            <v-spacer />
            <v-text-field
              clearable
              prepend-inner-icon="search"
              v-model="search"
            />
            <v-btn
              icon
              @click="initialize"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-card-title>
          <v-data-table
            :items="listData.listEntries"
            :loading="loading"
            :headers="headers"
            :items-per-page="100"
            :search="search"
          >
            <template v-slot:item.278a8988-0270-4215-b6ca-e7a8bb4ed98e_references_sort="{ item }">
              <div v-for="thing in item['278a8988-0270-4215-b6ca-e7a8bb4ed98e_references_sort']" :key="thing.id">
                {{ thing.displayString }}
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import api from "../../services/api.zenkit";

export default {
  name: "ConsumablesListViews",
  data() {
    return {
      loading: true,
      listData: {},
      search: "",
      headers: [
        { text: 'Title', value: '0c68d87c-880c-4d89-851a-268a208cb3da_text'},
        { text: 'Description', value: 'bec84878-ec28-4aba-a3ab-693e5673b4f1_text'},
        { text: 'Location', value: '278a8988-0270-4215-b6ca-e7a8bb4ed98e_references_sort'}
      ]
    }
  },
  methods: {
    initialize() {
      this.loading = true;
      api
        .post('lists/1tFNLddJ_/entries/filter/list', {
          "filter": {},
          "groupByElementId": 0,
          "limit": 1000,
          "skip": 0,
          "exclude": [],
          "allowDeprecated": false,
          "taskStyle": false
        })
        .then((response) => {
          this.listData = response.data
        })
        .finally(() => this.loading = false)
    }
  },
  mounted(){
    this.initialize()
  }
}
</script>
